import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { fetchGroups } from "features/management/vehicleGroup/groupsThunks";

const CreateGroupDialog = ({ open, onClose, onSuccess }) => {
    const dispatch = useDispatch();
  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!groupName.trim()) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        "https://v3.dhundhoo.com/ev/createThingGroupsMaster",
        {
          groupname: groupName,
          timeZone: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-dhundhoo-session": token,
          },
        }
      );

      onSuccess(response.data); // callback to refresh parent
      setGroupName("");
      // dispatch(fetchGroups());
      onClose();
    } catch (err) {
      console.error("Create group error:", err);
      alert("Error: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create New Group</DialogTitle>
      <Typography px={3}>
        Type a Group name and click create. All group names have to be unique.
      </Typography>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Group Name"
          fullWidth
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !groupName.trim()}
        >
          {loading ? <CircularProgress size={20} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ✅ Define prop-types
CreateGroupDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default CreateGroupDialog;
